import { employeeApis } from '@/api';
import JSEncrypt from 'jsencrypt';
import moment from 'moment';
export { getRedirectUrl, isSamlLogin } from './login';

export const encryptPassword = async (payload: string) => {
  const pubKeyResult = await employeeApis.getPublicKey();
  const encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKeyResult.key); // 设置 加密公钥
  return encryptStr.encrypt(payload + '&' + pubKeyResult.timestamp);
};

export const QrcodeIndexPathName = 'QrcodeIndexPath';
export const QrcodeIndexPath = '/qrcode/login';

export const formatterDatetime = (date: string) => {
  return moment(new Date(date)).format('YYYY-MM-DD HH:mm');
};
